import { render, staticRenderFns } from "./DictationItemMobile.vue?vue&type=template&id=5c4b8cdc&scoped=true"
import script from "./DictationItemMobile.vue?vue&type=script&lang=js"
export * from "./DictationItemMobile.vue?vue&type=script&lang=js"
import style0 from "./DictationItemMobile.vue?vue&type=style&index=0&id=5c4b8cdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4b8cdc",
  null
  
)

export default component.exports